import React from 'react';
import { useTranslation } from 'react-i18next';
import { Chip } from '@routific/hive/v5';

const ShopifyTag: React.FC = () => {
  const { t } = useTranslation('shopify');

  return (
    <Chip color="success" size="sm">
      {t('tag')}
    </Chip>
  );
};

export default ShopifyTag;
